import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';

$.addInit(function(context) {
	var base = '.b-address';
	$(base, context).each(function(){
		var component = $(this);
		var positions = component.find('.b-addressPosition');
		var map = component.find('.b-map');

		positions.on('click', function() {
			var coord = $(this).data('coord');

			map.trigger('setAddress', [coord]);

			positions.removeClass('m-active').not(positions).add(this).toggleClass('m-active');
		});

		// Фильтрация меток в табе
		var tabs = component.find('.b-tabs-tab');
		var isMapReady = false;

		function updateMap(filter) {
			map.trigger('filterPlace', [filter]);

			isMapReady = true;
		}

		function update(filter) {
			if (isMapReady) {
				updateMap(filter);
			} else {
				map.off('init', updateMap).on('init', function() {
					updateMap(filter)
				});
			}
		}

		tabs.on('active', function(e) {
			var filter = $(this).data('filter');

			update(filter);
		});
		// Фильтрация меток в табе

		function scrollToBlock(e) {
			e.preventDefault();
			var target = $(this).attr('href');
			var fixedOfset = 70;
			$('html,body').stop().animate({ scrollTop: map.offset().top - fixedOfset }, 1000);
		}

		breakpoint('xs', 'lg')
			.onmatch(function(){
				positions.on('click', scrollToBlock);
			})
			.onmismatch(function(){
				positions.off('click', scrollToBlock);
			});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-contacts.js
// module id = 33
// module chunks = 0